import { Box, Portal, Separator } from '@chakra-ui/react';
import { HiCheck, HiX } from 'react-icons/hi';
import FaceliftButton from '@/components/Atoms/FaceliftButton';
import FaceliftSwitch from '@/components/Atoms/FaceliftSwitch/FaceliftSwitch';
import type { DataTableColumnFilterMenuProps } from '@/components/Organisms/DataTable/DataTable.types';
import { useColorModeValue } from '@/components/ui/color-mode-utils';
import { colors } from '@/components/ui/theme';
import { MenuPrimitives as CustomMenu } from '@/types/MenuPrimitives.types';

const DataTableColumnFilterMenu = ({
	columns = [],
	trigger,
	hiddenColumn = [],
	setHiddenColumn,
}: DataTableColumnFilterMenuProps) => {
	const menuBorder = useColorModeValue('gray.200', 'gray.600');
	return (
		<CustomMenu.Root closeOnSelect={false}>
			<CustomMenu.Trigger>{trigger}</CustomMenu.Trigger>
			<Portal>
				<CustomMenu.Positioner>
					<CustomMenu.Content
						zIndex={1500}
						boxShadow={`0px 4px 4px 0px ${colors.menuListShadow}`}
						border="1px solid"
						borderColor={menuBorder}
					>
						<Box display="flex" gap={2} px={3} py={2}>
							<FaceliftButton
								bg="transparent"
								color="brand.inputText"
								_hover={{ bg: { base: 'gray.100', _dark: 'gray.900' } }}
								borderRadius={0}
								onClick={() => setHiddenColumn([])}
								disabled={hiddenColumn.length === 0}
							>
								Show All
							</FaceliftButton>
							<FaceliftButton
								bg="transparent"
								color="brand.inputText"
								_hover={{ bg: { base: 'gray.100', _dark: 'gray.900' } }}
								borderRadius={0}
								onClick={() => setHiddenColumn(columns.map((c) => c.key))}
								disabled={hiddenColumn.length === columns.length}
							>
								Hide All
							</FaceliftButton>
						</Box>
						<Separator />
						{columns.map(({ label, key }) => (
							<CustomMenu.Item key={key} px={1} py={2}>
								<Box display="flex" alignItems="center" gap={2}>
									<FaceliftSwitch
										size="sm"
										checked={!hiddenColumn.includes(key)}
										onCheckedChange={(checked) => {
											if (checked) {
												setHiddenColumn(
													hiddenColumn.filter((v: string) => v !== key),
												);
											} else {
												if (!hiddenColumn.includes(key)) {
													setHiddenColumn([...hiddenColumn, key]);
												}
											}
										}}
										checkedThumbIcon={<HiCheck />}
										unCheckedThumbIcon={<HiX color="black" />}
										label={label}
									/>
								</Box>
							</CustomMenu.Item>
						))}
					</CustomMenu.Content>
				</CustomMenu.Positioner>
			</Portal>
		</CustomMenu.Root>
	);
};

export default DataTableColumnFilterMenu;
